import {IconButton} from '@mui/material';
import React from 'react';
import XDark from '../../../assets/svg/xdark.svg';
import XWhite from '../../../assets/svg/xwhite.svg';
import Instagram from '../../../assets/svg/instagram.svg';
import Steam from '../../../assets/svg/steam.svg';
import Discord from '../../../assets/svg/discord.svg';
import {useSelector} from 'react-redux';
import {RootState} from '../../../store';


const SocialMedia = () => {
  const isDarkMode = useSelector(
      (state: RootState) => state.darkMode.isDarkMode
  );

  return (
      <div className="text-sm font-semibold  text-gray-700 dark:text-dark-text">
        <div className="text-lg text-dark-primary mb-3">Folgt uns auf</div>
        <div className="flex lg:flex-col relative lg:sticky right-3 lg:right:0 lg:justify-center lg:items-center">
          <IconButton
              aria-label="Instagram"
              href="https://instagram.com"
              target="_blank"
              className="relative bottom-1 text-light-text dark:text-dark-text"
          >
            <img src={Instagram} alt="Instagram" className="w-6 h-6"/>
          </IconButton>
          <IconButton
              aria-label="X"
              href="https://x.com"
              target="_blank"
              className="relative bottom-1 text-light-text dark:text-dark-text"
          >
            <img src={isDarkMode ? XWhite : XDark} alt="X" className="w-6 h-6"/>
          </IconButton>

          <IconButton
              aria-label="Steam"
              href="https://steamcommunity.com/groups/MoonSkinsGG"
              target="_blank"
              className="relative bottom-1 text-light-text dark:text-dark-text"
          >
            <img src={Steam} alt="Steam" className="w-6 h-6"/>
          </IconButton>

          <IconButton
              aria-label="Discord"
              href="https://discord.gg/MoonSkinsGG"
              target="_blank"
              className="relative bottom-1 text-light-text dark:text-dark-text"
          >
            <img src={Discord} alt="Discord" className="w-6 h-6"/>
          </IconButton>
        </div>
      </div>
  );
};

export default SocialMedia;
